import { render, staticRenderFns } from "./ThemeProductSwiper.vue?vue&type=template&id=44ae960e&scoped=true&"
import script from "./ThemeProductSwiper.vue?vue&type=script&lang=js&"
export * from "./ThemeProductSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ThemeProductSwiper.vue?vue&type=style&index=0&id=44ae960e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ae960e",
  null
  
)

export default component.exports